import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BookOpen, Lightbulb, TrendingUp, Users } from "lucide-react";

const DicasPage = () => {
  const dicas = [
    {
      icon: BookOpen,
      title: "Como fazer um currículo atrativo",
      category: "Currículo",
      description: "Aprenda as melhores práticas para criar um currículo que chama atenção dos recrutadores.",
      tips: [
        "Use um formato limpo e profissional",
        "Destaque suas principais conquistas com números",
        "Adapte o currículo para cada vaga",
        "Revise ortografia e gramática"
      ]
    },
    {
      icon: Lightbulb,
      title: "Preparação para entrevistas",
      category: "Entrevista",
      description: "Dicas essenciais para se sair bem em entrevistas de emprego.",
      tips: [
        "Pesquise sobre a empresa antes",
        "Prepare respostas para perguntas comuns",
        "Vista-se adequadamente",
        "Chegue com 10-15 minutos de antecedência"
      ]
    },
    {
      icon: TrendingUp,
      title: "Desenvolvimento de carreira",
      category: "Carreira",
      description: "Estratégias para crescimento profissional e progressão na carreira.",
      tips: [
        "Invista em cursos e certificações",
        "Construa uma rede de contatos profissional",
        "Busque feedback constante",
        "Defina metas de carreira claras"
      ]
    },
    {
      icon: Users,
      title: "Networking efetivo",
      category: "Networking",
      description: "Como construir e manter uma rede de contatos profissional forte.",
      tips: [
        "Participe de eventos da sua área",
        "Mantenha seu LinkedIn atualizado",
        "Ajude outros profissionais",
        "Mantenha contato com ex-colegas"
      ]
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1">
        <section className="py-12 bg-muted/30">
          <div className="container">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <Badge variant="featured" className="mb-4">Dicas de Carreira</Badge>
              <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
                Acelere sua carreira
              </h1>
              <p className="text-lg text-muted-foreground">
                Conselhos práticos para ajudar você a se destacar no mercado de trabalho
              </p>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container">
            <div className="mobile-container md:w-full grid gap-6 md:grid-cols-2">
              {dicas.map((dica, index) => {
                const Icon = dica.icon;
                return (
                  <Card key={index} className="hover:shadow-lg transition-shadow">
                    <CardHeader>
                      <div className="flex items-start gap-4">
                        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                          <Icon className="h-6 w-6 text-primary" />
                        </div>
                        <div className="flex-1">
                          <Badge variant="secondary" className="mb-2">
                            {dica.category}
                          </Badge>
                          <CardTitle className="text-xl font-display">{dica.title}</CardTitle>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <p className="text-muted-foreground mb-4">{dica.description}</p>
                      <ul className="space-y-2">
                        {dica.tips.map((tip, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm">
                            <span className="text-primary mt-0.5">•</span>
                            <span>{tip}</span>
                          </li>
                        ))}
                      </ul>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default DicasPage;
